export function normalizeConfig(fullJson) {
    if (!fullJson?.configuration) return {};
    try {
        const parsed = typeof fullJson.configuration === 'string'
            ? JSON.parse(fullJson.configuration)
            : fullJson.configuration;
        return fullJson.type_action === 'BUTTON'
            ? { button: [parsed], table: [], select_company: false }
            : parsed;
    } catch { return {}; }
}
 
export function parseFlowProcess(raw) {
    if (!raw) return [];
    try {
        const p = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (Array.isArray(p)) return p;
        if (Array.isArray(p?.flow_process)) return p.flow_process;
        return [];
    } catch { return []; }
}
 
export function generateMockRows(visibleColumns, count = 9) {
    const statuses = ['ASIGNADA', 'EN USO', 'CERRADA'];
    return Array.from({ length: count }).map((_, i) => {
        const row = { _id: i + 1 };
        visibleColumns.forEach(col => {
            if (col.type === 'money') {
                const num = Math.floor(Math.random() * 9_000_000) + 100_000;
                row[col.id] = `$ ${num.toLocaleString('es-CO')}`;
            } else if (col.id === 'status') {
                row[col.id] = statuses[i % 3];
            } else {
                row[col.id] = `${col.label} ${count - i}`;
            }
        });
        return row;
    });
}